/*
  Aza Natural: 'Maak het compleet' op de productpagina (upgrade PDP-08).

  Markup: snippets/aza-pdp-addons.liquid. Aangevinkte producten gaan mee met
  de hoofdknop: ProductForm (component-product-form.js) leest de vinkjes en
  stuurt alles in één /cart/add.js met items. Deze knop drukt op die
  hoofdknop, zodat er maar één route naar de winkelmand is. Na een geslaagde
  toevoeging gaan de vinkjes weer uit.
*/
(() => {
  if (window.azaAddonsKlaar) return;
  window.azaAddonsKlaar = true;

  const varianten = (box) => document.querySelector(`product-variants[data-id="${box.dataset.section}"]`);
  const formulier = (box) => document.getElementById(box.dataset.form);

  function bijwerken(box) {
    const knop = box.querySelector('[data-aza-addons-knop]');
    if (!knop) return;
    const vinken = [...box.querySelectorAll('.aza-addons__vink:checked')];
    if (!vinken.length) {
      knop.hidden = true;
      return;
    }
    const pv = varianten(box);
    const form = formulier(box);
    const aantal = parseInt(form?.querySelector('[name="quantity"]')?.value || '1', 10) || 1;
    const hoofd = pv?.currentVariant ? pv.currentVariant.price * aantal : 0;
    const totaal = hoofd + vinken.reduce((som, v) => som + (parseInt(v.dataset.prijs, 10) || 0), 0);
    const prijs = pv && typeof pv._azaFormatPrice === 'function' ? pv._azaFormatPrice(totaal) : (totaal / 100).toFixed(2).replace('.', ',');
    knop.textContent = (box.dataset.knoptekst || '').replace('[prijs]', prijs);
    knop.hidden = false;
    const hoofdknop = form?.querySelector('[type="submit"]');
    knop.disabled = Boolean(hoofdknop && hoofdknop.disabled);
  }

  function init(box) {
    if (box.dataset.azaAddonsInit) return;
    box.dataset.azaAddonsInit = '1';
    varianten(box)?.addEventListener('VARIANT_CHANGE', () => bijwerken(box));
    formulier(box)?.closest('product-form')?.addEventListener('add-to-cart', () => {
      const gekozen = [...box.querySelectorAll('.aza-addons__vink:checked')];
      if (gekozen.length && window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('aza_pdp_addons_add', { count: gekozen.length, variants: gekozen.map((v) => v.value) });
      }
      gekozen.forEach((v) => { v.checked = false; });
      bijwerken(box);
    });
  }

  document.addEventListener('change', (e) => {
    const box = e.target.closest?.('[data-aza-addons]');
    if (box) bijwerken(box);
    // Aantal of variant gewijzigd: totaal in de knop bijwerken.
    if (e.target.closest?.('product-form, product-quantity')) {
      document.querySelectorAll('[data-aza-addons]').forEach(bijwerken);
    }
  });

  document.addEventListener('click', (e) => {
    const knop = e.target.closest?.('[data-aza-addons-knop]');
    if (!knop || knop.disabled) return;
    const hoofdknop = formulier(knop.closest('[data-aza-addons]'))?.querySelector('[type="submit"]');
    if (hoofdknop && !hoofdknop.disabled) hoofdknop.click();
  });

  const start = () => document.querySelectorAll('[data-aza-addons]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
